<div class="proviLoader__wrapper">
  <div class="proviLoader">
    <ul class="proviLoader__blast">
      <li />
      <li />
      <li />
    </ul>
    <div class="proviLoader__wineglass proviLoader__wineglass-left">
      <div class="proviLoader__top" />
    </div>
    <div class="proviLoader__wineglass proviLoader__wineglass-right">
      <div class="proviLoader__top" />
    </div>
    <slot />
  </div>
</div>
